import _ from 'lodash'
import type { ResolvedRefArray, PresetData } from '@wix/thunderbolt-becky-types'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { DataItemWithOverridesRefs } from '../../types'

export const Presets = createConsumptionDataNode<null, null, DataItemWithOverridesRefs>({
	toViewItem: ({ id, value: { dataItemWithOverrides } }) => {
		const dataItems = _(dataItemWithOverrides)
			.filter((dataItem) => !!dataItem)
			.value()

		if (dataItems.length === 0) {
			return
		}

		// merge values of all overrides and unresolve refArray
		const values = _(dataItems)
			.flatMap((dataItem) => (dataItem as ResolvedRefArray<PresetData>).values)
			.filter((value) => !!value)
			.map((value) => `#${value.id}`)
			.value()

		return {
			...dataItems[0],
			id,
			values,
		}
	},
})
